<template>
  <div class="report--responses auto-list_col_centered">
    <div class="driver">
      <p class="check-list-phone grey">
        {{ organization.short_name || 'Нет данных' }}
      </p>
      <p class="report--responses--driver-name">
        Водитель: {{ shortFio(driver.fio) || 'Нет данных' }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Driver',
  props: {
    driver: {
      type: Object,
      default: () => {},
    },
    organization: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="sass">
.report--responses
  .driver
    p
      text-align: left
      margin: 10px 0
  &--driver-name
    font-size: 12px
</style>
